import PropTypes from 'prop-types';
import React, {Component} from 'react';

import Dialog from '../Dialog';
import TimeDialogCell from './TimeDialogCell';

class TimeDialog extends Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    isRecall: PropTypes.bool.isRequired,
    isApprove: PropTypes.bool.isRequired,
    totals: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
  };

  static state = {
    dates: {}
  };

  handleSelectionChange(total) {
    const {dates = {}} = this.state || {};
    const {Date: date, Total: amount} = total;
    const key = date.format('YYYY-MM-DD');

    if (typeof dates[key] === 'undefined') {
      dates[key] = amount;
    } else {
      delete dates[key];
    }

    this.setState({dates});
  }

  SelectAll(totals) {
    // Pick every cell that's eligible for the current dialog mode (submit,
    // approve, recall-to-employee, recall-to-approver) and add it to the
    // selection.  Previously this reached into React's private fiber tree
    // (this._reactInternalFiber.*) to read both the mode flags and each
    // cell's `checked` prop - that API was renamed in React 16.14 and
    // removed in 17+, so under CRA 5 (React 18) the first property access
    // threw and the entire loop silently bailed, which is why Select All
    // stopped doing anything.  The mode flags are just props on this
    // component, and "is this date already selected?" is equivalent to
    // `typeof dates[key] !== 'undefined'` (same check the render method
    // uses to drive each cell's `checked`).
    const {isRecall, isApprove, isRecalltoApprover} = this.props;
    const {dates: prevDates = {}} = this.state || {};
    const dates = {...prevDates};
    const now = Date.now();

    totals.forEach(total => {
      const {Date: date, Total: amount} = total;
      const key = date.format('YYYY-MM-DD');

      // Already checked - leave it alone (Select All should never un-check).
      if (typeof dates[key] !== 'undefined') return;

      const submitted = !!total.Submitted;
      const approved = !!total.Approved;
      const posted = !!total.Posted;

      if (isApprove) {
        if (!posted && !approved && submitted) dates[key] = amount;
        return;
      }
      if (isRecall) {
        if (isRecalltoApprover) {
          if (!posted && approved && submitted) dates[key] = amount;
        } else {
          if (!posted && !approved && submitted) dates[key] = amount;
        }
        return;
      }
      // Submit path (timesheet page): today or earlier, not yet submitted.
      if (date <= now && !submitted) {
        dates[key] = amount;
      }
    });

    this.setState({dates});
  }

  ClearAll() {
    this.setState({dates: {}});
  }

  render() {
    const {heading, onClose, onSave, isRecall, isApprove, isRecalltoApprover, totals, title} = this.props;

    const {dates = {}} = this.state || {};

    const numSelected = Object.keys(dates).length;
    const amount = Object.keys(dates).reduce((acc, key) => acc + dates[key], 0);

    return (
      <Dialog
        className="time-dialog"
        enableConfirm={numSelected > 0}
        showSelectAll = {true}
        showClearAll = {true}
        onConfirm={() => onSave(Object.keys(dates))}
        onDismiss={onClose}
        onSelectAll= {() => this.SelectAll(totals)}        
        onClearAll= {() => this.ClearAll()}
        isRecall={isRecall}
        isRecalltoApprover={isRecalltoApprover}
        isApprove={isApprove}
        title={title}>
        <div className="time-dialog-content">
          {heading &&
            heading.length > 0 && (
              <p className="time-dialog-heading">{heading}</p>
            )}
          <div className="time-dialog-cells col-md-12">
            {totals.map((total, i) => (
              <TimeDialogCell
                amount={total.Total}
                approved={total.Approved}
                checked={
                  typeof dates[total.Date.format('YYYY-MM-DD')] !== 'undefined'
                }
                date={total.Date}
                disabled={total.Disabled}
                key={i}
                message={total.Message}
                onChange={e => this.handleSelectionChange(total)}
                posted={total.Posted}
                readOnly={total.Date > Date.now() || total.Total > 24}
                submitted={total.Submitted}
              />
            ))}
            <div className="time-dialog-cell time-dialog-totals">
              <p className="time-dialog-cell-title">
                Total Selected<br />Hours
              </p>
              <div className="time-dialog-cell-content">{amount.toFixed(2)}</div>
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default TimeDialog;
